import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { theme } from '@vfit/shared/themes';
// import { animations, colors, getTypography, pxToRem } from '@vfit/shared/themes';
import { IInputsForSC } from '../../inputs.models';

const fadeEnter = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeExit = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

const fadeAnimation = css`
  &.error-enter {
    animation: ${fadeEnter} 0.3s forwards;
  }

  &.error-exit {
    animation: ${fadeExit} 0.3s forwards;
  }
`;

// const variants = {
//   errorMessage: {
//     animated: css`
//       ${getTypography('footnote2.regular')}
//       height: 24px;
//     `,
//     'mva:animated': css`
//       ${getTypography('footnote1.regular')}
//       height: 18px;
//     `,
//     'mva:static': css`
//       ${getTypography('footnote1.regular')}
//       height: 24px;
//     `,
//   },
// };
const variants = {
  errorMessage: {
    animated: css`
      height: ${theme.spacing.lg};
    `,
    'mva:animated': css`
      height: ${theme.spacing.md};
    `,
    'mva:static': css`
      height: ${theme.spacing.md};
    `,
  },
};

export const ErrorMessage = styled.p<IInputsForSC>`
  ${fadeAnimation}
  align-items: center;
  bottom: 0;
  color: ${theme.colors.text.linkHover};
  column-gap: ${theme.spacing.xs};
  display: flex;
  left: 0;
  margin: 0;
  position: absolute;
  ${({ variant }) => (variant ? variants.errorMessage[variant] : '')}
`;

